/**
 * TanStack Query hooks for `igaming-cpa`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingCpaQueryKeys,
	type CreateIgamingCpaBody,
	type ListIgamingCpaResponse,
	type IgamingCpaRow,
} from "./api";

export function useIgamingCpaList(): UseQueryResult<ListIgamingCpaResponse, Error> {
	return useQuery({
		queryKey: igamingCpaQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingCpaCreate(): UseMutationResult<IgamingCpaRow, Error, CreateIgamingCpaBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingCpaQueryKeys.all });
		},
	});
}

export function useIgamingCpaDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingCpaQueryKeys.all });
		},
	});
}
